import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useItemStore } from '@/js/lib/store/item';
import { useUserStore } from '@/js/lib/store/user';
import FollowRecommend from './followRecommend.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'followRecommendIfItemLiked',
  props: {
    itemId: { default: undefined },
    memberId: {}
  },
  setup(__props: any) {


const userStore = useUserStore();
const itemStore = useItemStore();

return (_ctx: any,_cache: any) => {
  return (_ctx.memberId !== _unref(userStore).memberId && _unref(itemStore).likedItemIds.includes(_ctx.itemId))
    ? (_openBlock(), _createBlock(FollowRecommend, {
        key: 0,
        "member-id": _ctx.memberId,
        placement: "bottom-end"
      }, null, 8, ["member-id"]))
    : _createCommentVNode("", true)
}
}

})